module.exports = __webpack_public_path__ + "static/img/cont34 (7).a526781.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont34 (7).jpg
// module id = Lw8m
// module chunks = 0